import React from "react";
import { TextField } from "material-ui";
import { formatPercent } from "../../util";

/**
 * Display percent (0.0000 - 1.0000) in user-friendly X.XX% format.
 */
class PercentField extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      editedValue: null
    };

    this._handleInputChange = this._handleInputChange.bind(this);
    this._handleInputBlur = this._handleInputBlur.bind(this);
  }

  _handleInputChange(e) {
    let { value } = e.target;

    this.setState({
      editedValue: value
    });

    this.props.onChange({
      target: {
        value: value.replace(/[^0-9\.]/g, "") / 100
      }
    });
  }

  _handleInputBlur() {
    this.setState({ editedValue: null });
  }

  render() {
    let { value, onChange, onBlur, placeholder, ...props } = this.props,
      { editedValue } = this.state;

    return (
      <TextField
        value={
          editedValue !== null
            ? editedValue
            : value
            ? `${formatPercent(value)}`
            : ""
        }
        onChange={this._handleInputChange}
        onBlur={this._handleInputBlur}
        placeholder={placeholder || "0%"}
        {...props}
      />
    );
  }
}

export default PercentField;



// WEBPACK FOOTER //
// ./src/app/components/partials/percent-field.jsx